// Admin-Token aus dem Dashboard-Login. Bleibt dauerhaft auf dem Gerät gespeichert,
// bis über "Log out" abgemeldet wird (oder der Server den Token ablehnt).
const TOKEN_KEY = 'reverend_admin_token'

export function readAdminToken() {
  try {
    const stored = localStorage.getItem(TOKEN_KEY)
    if (stored) return stored
    // Ältere Logins lagen nur im sessionStorage → einmalig übernehmen
    const legacy = sessionStorage.getItem(TOKEN_KEY)
    if (legacy) {
      localStorage.setItem(TOKEN_KEY, legacy)
      sessionStorage.removeItem(TOKEN_KEY)
      return legacy
    }
  } catch { /* Storage nicht verfügbar */ }
  return ''
}

export function writeAdminToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token)
    else localStorage.removeItem(TOKEN_KEY)
    sessionStorage.removeItem(TOKEN_KEY)
  } catch { /* Storage nicht verfügbar */ }
}
